
require("regenerator-runtime/runtime");// CommonJS
import "regenerator-runtime/runtime.js";// ECMAScript 2015

import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import Constants from "@/plugins/constants";
import { setInitialAxiosCancelToken } from "@/helpers/main";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

// Disable debug in production
const isDevelopment = process.env.MODE == "DEVELOPMENT";
const sentryAllowedURLs = process.env.SENTRY_ALLOWED_URLS.split(",");
Vue.config.devtools = isDevelopment;
Vue.config.debug = isDevelopment;
Vue.config.silent = !isDevelopment;

Sentry.init({
  Vue,
  dsn: process.env.SENTRY_DSN,
  beforeSend(event) {
    if(sentryAllowedURLs.some(allowedURL=>event.request.url.includes(allowedURL))){
      return  event;
    }

    return null;
  },
  enabled: !isDevelopment && sentryAllowedURLs.includes(window.location.hostname),
  autoSessionTracking: true,
  tracesSampleRate: 1.0,
  environment: process.env.MODE.toLowerCase(),
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router)
    })
  ]
});

setInitialAxiosCancelToken();


Vue.use(Constants);

new Vue({
    el: "#root",
    router,
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js